<template>
  <v-container class="no-margins">
    <h2 v-if="title">{{ title}}</h2>
    <v-card flat v-if="options && options.length > 0">
      <v-card-actions v-for="(item,index) in options" :key="index" :class="`${margin} pa-0`">
        <v-btn
          block
          :disabled="item.disabled"
          v-if="checkUser(item.user)"
          :class="`btn-label ${type} ${item.cssClass}`"
          @click="$nextTick(()=>{$router.push(item.route)})"
        >
          <v-icon v-if="item.actionIcon">{{ item.actionIcon }}</v-icon>
          {{ item.title }}
          <div v-if="badge" class="numberCircle icon-far-right">
            <div class="badgeNum">{{badge}}</div>
          </div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import ActionButton from '@/components/Common/ActionButton'
// @group Common
// Styled ButtonArray component
export default {
  name: 'ButtonArray',

  props: {
    //has title
    title: {
      type: String,
      default: ''
    },    
    // The type of the ActionButton
    type: {
      //--TODO add secondary css
      // `'action'` / `'destructive'` / `'secondary'`
      type: String,
      // The default value is: `action`
      default: 'action'
    },
    // Buttons array
    options: {
      // `'Array'`
      type: Array,
      // The default value is: `[]`
      default: []
    },
    //has a css class
    margin: {
      // `'String'`
      type: String,
      // The default value is: `mb-4`
      default: 'mb-4'
    },
    // Should we display a number in a badge
    badge: {
      // Non-zero # to display in badge
      type: Number,
      // The default value is: 0
      default: 0
    }
  },
  components: {
    ActionButton
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isCompanyUser'])
  },
  methods: {
    /**
     * @vuese
     * Used to check the user and return boolean based on which user is in User object
     * @arg the argument is string representing user role
     */
    checkUser(user) {
      if (!user) return false;
      if (this[user]) return true;
      return false;
    }
  }
}
</script>
